@if (routeConceptId()) {
  <div class="prompt-edit animate-fade-in">
    <a class="prompt-edit__back" [routerLink]="routeSlug() ? ['/prompts', routeSlug()] : ['/prompts']">
      ← {{ selectedApp()?.app_name || 'Prompts' }}
    </a>

    @if (editLoading()) {
      <div class="concepts-loading" role="status">
        <svg class="concepts-loading__spinner" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
        <span>Loading prompt…</span>
      </div>
    } @else if (editLoadError()) {
      <div class="concepts-error" role="alert">{{ editLoadError() }}</div>
    } @else if (selectedConcept()) {
      <div class="concepts-modal concepts-modal--form prompt-edit__panel">
        <div class="concepts-modal__header">
          <h1 id="edit-page-title" class="concepts-modal__title">Edit — {{ selectedConcept()?.title }}</h1>
        </div>
        <form [formGroup]="editForm" (ngSubmit)="submitEdit()" class="prompt-edit__form" id="edit-form">
          <div class="prompt-edit__split">
            <div class="prompt-edit__main">
              <div class="concepts-form__group">
                <label class="concepts-form__label" for="edit-title">Title *</label>
                <input id="edit-title" formControlName="title" type="text" class="concepts-form__input"
                  [class.concepts-form__input--error]="editForm.get('title')?.invalid && editForm.get('title')?.touched"
                  [attr.aria-invalid]="editForm.get('title')?.invalid && editForm.get('title')?.touched">
                @if (editForm.get('title')?.invalid && editForm.get('title')?.touched) {
                  <span class="concepts-form__error" role="alert">Title is required</span>
                }
              </div>
              <div class="concepts-form__group prompt-edit__prompt-group">
                <label class="concepts-form__label" for="edit-prompt">Prompt *</label>
                <textarea id="edit-prompt" formControlName="prompt" rows="18" class="concepts-form__input concepts-form__textarea prompt-edit__prompt"
                  [class.concepts-form__input--error]="editForm.get('prompt')?.invalid && editForm.get('prompt')?.touched"
                  [attr.aria-invalid]="editForm.get('prompt')?.invalid && editForm.get('prompt')?.touched"></textarea>
                @if (editForm.get('prompt')?.invalid && editForm.get('prompt')?.touched) {
                  <span class="concepts-form__error" role="alert">Prompt is required</span>
                }
              </div>
            </div>

            <div class="prompt-edit__side">
          <div class="concepts-form__group concepts-form__group--row">
            <label class="concepts-form__checkbox-label">
              <input type="checkbox" formControlName="is_active" class="concepts-form__checkbox">
              <span>Active</span>
            </label>
            <label class="concepts-form__checkbox-label">
              <input type="checkbox" formControlName="generate_image" class="concepts-form__checkbox">
              <span>Generate image</span>
            </label>
            <label class="concepts-form__checkbox-label">
              <input type="checkbox" formControlName="generate_body" class="concepts-form__checkbox">
              <span>Generate body</span>
            </label>
          </div>

        <div class="concepts-modal__lang-section">
          <label class="concepts-form__label" id="edit-langs-label">Languages</label>
          @if (editSelectedLangs().length) {
            <div class="lang-chips" aria-label="Selected languages">
              @for (code of editSelectedLangs(); track code) {
                <span class="lang-chip">
                  {{ getLangName(code) }}
                  <button type="button" class="lang-chip__remove" (click)="removeLang('edit', code)" [attr.aria-label]="'Remove ' + getLangName(code)">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  </button>
                </span>
              }
            </div>
          }
          <div class="lang-select-wrap">
            <button type="button" class="lang-select-btn" (click)="editLangOpen.update(v => !v)"
              aria-haspopup="listbox" [attr.aria-expanded]="editLangOpen()" aria-labelledby="edit-langs-label">
              <span>{{ editSelectedLangs().length ? editSelectedLangs().length + ' language' + (editSelectedLangs().length > 1 ? 's' : '') + ' selected' : 'Select languages…' }}</span>
              <svg class="lang-select-arrow" [class.lang-select-arrow--open]="editLangOpen()" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 4.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
            </button>
            @if (editLangOpen()) {
              <div class="lang-backdrop" (click)="editLangOpen.set(false)"></div>
              <ul class="lang-dropdown" role="listbox" aria-multiselectable="true" aria-labelledby="edit-langs-label">
                @for (lang of languages; track lang.code) {
                  <li role="option" [attr.aria-selected]="editSelectedLangs().includes(lang.code)">
                    <button type="button" class="lang-option" [class.lang-option--selected]="editSelectedLangs().includes(lang.code)"
                      (click)="toggleLang('edit', lang.code)">
                      <span class="lang-option__check">
                        @if (editSelectedLangs().includes(lang.code)) {
                          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1.5 6l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
                        }
                      </span>
                      <span>{{ lang.name }}</span>
                      <span class="lang-option__code">{{ lang.code }}</span>
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        </div>

        <div class="concepts-modal__lang-section">
          <label class="concepts-form__label" for="edit-tag-input">Tags</label>
          <div class="tag-input-wrap">
            <input
              id="edit-tag-input"
              type="text"
              class="tag-input"
              placeholder="Type a tag and press Enter…"
              [ngModel]="editTagInput()"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="editTagInput.set($event)"
              (keydown)="onTagKeydown('edit', $event)"
              aria-label="Add tag"/>
            <button type="button" class="tag-add-btn" (click)="addTag('edit', editTagInput())" aria-label="Add tag">+</button>
          </div>
          @if (editTags().length) {
            <div class="lang-chips" aria-label="Tags" style="margin-top:0.5rem">
              @for (tag of editTags(); track tag) {
                <span class="lang-chip tag-chip">
                  {{ tag }}
                  <button type="button" class="lang-chip__remove" (click)="removeTag('edit', tag)" [attr.aria-label]="'Remove tag ' + tag">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                  </button>
                </span>
              }
            </div>
          }
        </div>

        <div class="inference-panel">
          <div class="inference-panel__header">
            <span class="inference-panel__title">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
              Test Prompt
            </span>
            <div class="inference-panel__controls">
              <select
                class="inference-lang-select"
                [ngModel]="inferenceLanguage()"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="inferenceLanguage.set($event)"
                aria-label="Language for inference">
                @for (code of editSelectedLangs(); track code) {
                  <option [value]="code">{{ getLangName(code) }}</option>
                }
                @if (!editSelectedLangs().length) {
                  <option value="">Default</option>
                }
              </select>
              <button
                type="button"
                class="inference-run-btn"
                (click)="runInference()"
                [disabled]="inferenceLoading()"
                aria-label="Run inference">
                @if (inferenceLoading()) {
                  <svg class="inference-spinner" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="60" stroke-dashoffset="20"/></svg>
                  Running…
                } @else {
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><polygon points="5,3 19,12 5,21" fill="currentColor"/></svg>
                  Run
                }
              </button>
            </div>
          </div>
          @if (inferenceError()) {
            <div class="inference-error" role="alert">{{ inferenceError() }}</div>
          }
          @if (!inferenceView() && !inferenceError() && !inferenceLoading()) {
            <p class="inference-empty">Run the prompt to see the generated output here.</p>
          }
        </div>
            </div>
          </div>
          @if (inferenceView(); as view) {
            <div class="prompt-edit__result">
              @if (view.kind === 'article') {
                <article class="inference-article">
                  @if (view.language || view.model) {
                    <div class="inference-article__meta">
                      @if (view.language) { <span>{{ getLangName(view.language) }}</span> }
                      @if (view.model) { <span>{{ view.model }}</span> }
                    </div>
                  }
                  @if (view.title) {
                    <h2 class="inference-article__title">{{ view.title }}</h2>
                  }
                  @for (paragraph of view.paragraphs; track $index) {
                    <p>{{ paragraph }}</p>
                  }
                  @if (view.promptSent) {
                    <details class="inference-article__prompt">
                      <summary>Prompt sent</summary>
                      <p>{{ view.promptSent }}</p>
                    </details>
                  }
                </article>
                <pre class="inference-output">{{ view.json }}</pre>
              } @else {
                <pre class="inference-output">{{ view.text }}</pre>
              }
            </div>
          }
          @if (saveError()) { <div class="concepts-form__alert concepts-form__alert--error" role="alert">{{ saveError() }}</div> }
          @if (saveSuccess()) { <div class="concepts-form__alert concepts-form__alert--success" role="status">{{ saveSuccess() }}</div> }
        </form>

        <div class="concepts-modal__footer">
          <button type="button" class="concepts-modal__btn concepts-modal__btn--danger" (click)="openDeleteModal(selectedConcept()!)" [disabled]="!selectedConcept()">Delete</button>
          <button type="button" class="concepts-modal__btn concepts-modal__btn--primary" (click)="submitEdit()" [disabled]="isSaving() || editForm.invalid || !hasEditChanges()">
            @if (isSaving()) { Saving… } @else { Save }
          </button>
        </div>
      </div>
    }
  </div>
} @else {
<div class="concepts-page animate-fade-in">
  @for (appId of [selectedAppId()]; track appId) {
  <div class="concepts-view" animate.enter="concepts-fade-in" (animate.leave)="fadeStageOut($event)">

  <!-- Header -->
  <header class="concepts-header">
    <div class="concepts-header__title">
      <svg class="concepts-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
      </svg>
      <div>
        <h1 class="concepts-header__headline">
          @if (appId) {
            {{ appName(appId) }} Prompts
          } @else {
            Prompts
          }
        </h1>
        <p class="concepts-header__sub">
          @if (appId) {
            Managing prompts for {{ appName(appId) }}.
          } @else {
            Tap an app to open its prompts.
          }
        </p>
      </div>
    </div>
    <div class="concepts-header__actions">
      @if (!appId) {
        <label class="app-picker__search">
          <svg class="app-picker__search-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z"/>
          </svg>
          <input
            type="search"
            class="app-picker__search-input"
            placeholder="Search apps"
            aria-label="Search apps by name"
            [ngModel]="appQuery()"
            (ngModelChange)="appQuery.set($event)">
        </label>
      } @else {
        <span class="concepts-header__label" id="app-select-label">App</span>
        <div class="prompt-drop" (click)="$event.stopPropagation()">
          <button type="button" id="app-select" class="concepts-header__select"
            aria-haspopup="listbox" [attr.aria-expanded]="appMenuOpen()" aria-labelledby="app-select-label"
            [disabled]="appsLoading()" (click)="toggleAppMenu()">
            <span>{{ appMenuLabel() }}</span>
            <svg class="prompt-drop__chevron" [class.prompt-drop__chevron--open]="appMenuOpen() && !appMenuClosing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
            </svg>
          </button>
          @if (appMenuOpen()) {
            <div class="prompt-drop__menu" [class.prompt-drop__menu--closing]="appMenuClosing()" role="listbox" aria-labelledby="app-select-label">
              <button type="button" class="prompt-drop__option" role="option" [attr.aria-selected]="!appId" [class.prompt-drop__option--active]="!appId" (click)="chooseApp('')">All apps</button>
              @for (app of apps(); track app.app_id) {
                <button type="button" class="prompt-drop__option" role="option" [attr.aria-selected]="app.app_id === appId" [class.prompt-drop__option--active]="app.app_id === appId" (click)="chooseApp(app.app_id)">{{ app.app_name }}</button>
              }
            </div>
          }
        </div>
        <button type="button" (click)="refreshConcepts()" class="concepts-header__btn concepts-header__btn--ghost" [disabled]="isLoading()" aria-label="Refresh concepts">
          <svg class="w-4 h-4 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
        </button>
      }
    </div>
  </header>

  @if (errorMsg()) {
    <div class="concepts-error" role="alert">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      {{ errorMsg() }}
    </div>
  }

  <!-- Canvas -->
  <section class="concepts-canvas-wrap" aria-label="Prompts">
    @if (!appId) {
      <div class="concepts-stage">
      @if (appsLoading()) {
        <div class="concepts-loading" role="status" aria-live="polite">
          <svg class="concepts-loading__spinner" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
          <span>Loading apps…</span>
        </div>
      } @else if (apps().length === 0) {
        <div class="concepts-empty">
          <h2 class="concepts-empty__title">No apps yet</h2>
          <p class="concepts-empty__text">Register an app before managing its prompts.</p>
        </div>
      } @else {
        <div class="app-picker">
          @if (filteredApps().length === 0) {
            <div class="concepts-empty">
              <h2 class="concepts-empty__title">No matching apps</h2>
              <p class="concepts-empty__text">No app name contains “{{ appQuery().trim() }}”.</p>
            </div>
          } @else {
          <div class="app-picker__grid" role="list">
            @for (app of filteredApps(); track app.app_id) {
              <button
                type="button"
                class="app-picker__card"
                (click)="onAppChange(app.app_id)"
                [attr.aria-label]="'Open prompts for ' + app.app_name">
                <span class="app-picker__icon" aria-hidden="true">
                  @if (app.app_icon) {
                    <img [src]="app.app_icon" [alt]="''" class="app-picker__img">
                  } @else {
                    {{ app.app_name.charAt(0).toUpperCase() }}
                  }
                </span>
                <span class="app-picker__body">
                  <span class="app-picker__name">{{ app.app_name }}</span>
                  <span class="app-picker__meta">{{ appInfoLine(app) }}</span>
                </span>
                <span
                  class="app-picker__status"
                  [class.app-picker__status--active]="app.is_active"
                  [class.app-picker__status--inactive]="!app.is_active">
                  {{ app.is_active ? 'Active' : 'Inactive' }}
                </span>
              </button>
            }
          </div>
          }
        </div>
      }
      </div>

    } @else {
      <div class="concepts-stage">
      @if (isLoading()) {
      <div class="concepts-loading" role="status" aria-live="polite">
        <svg class="concepts-loading__spinner" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
        <span>Loading prompts…</span>
      </div>

      } @else {
      <div class="prompt-list">
        <div class="prompt-list__bar">
          <div class="prompt-list__filters">
            <span class="concepts-header__label" id="tag-filter-label">Tag</span>
            <div class="prompt-drop" (click)="$event.stopPropagation()">
              <button type="button" id="tag-filter" class="prompt-list__tag-select"
                aria-haspopup="listbox" [attr.aria-expanded]="tagMenuOpen()" aria-labelledby="tag-filter-label"
                [disabled]="availableTags().length === 0" (click)="toggleTagMenu()">
                <span>{{ tagMenuLabel() }}</span>
                <svg class="prompt-drop__chevron" [class.prompt-drop__chevron--open]="tagMenuOpen() && !tagMenuClosing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/>
                </svg>
              </button>
              @if (tagMenuOpen()) {
                <div class="prompt-drop__menu" [class.prompt-drop__menu--closing]="tagMenuClosing()" role="listbox" aria-labelledby="tag-filter-label">
                  <button type="button" class="prompt-drop__option" role="option" [attr.aria-selected]="!selectedTag()" [class.prompt-drop__option--active]="!selectedTag()" (click)="chooseTag('')">All tags</button>
                  @for (tag of availableTags(); track tag) {
                    <button type="button" class="prompt-drop__option" role="option" [attr.aria-selected]="selectedTag() === tag" [class.prompt-drop__option--active]="selectedTag() === tag" (click)="chooseTag(tag)">{{ tag }}</button>
                  }
                </div>
              }
            </div>
            <p class="prompt-list__count">{{ filteredConcepts().length }} prompt{{ filteredConcepts().length === 1 ? '' : 's' }}</p>
          </div>
          <button type="button" class="prompt-list__add" (click)="openCreateModal()">
            <svg class="prompt-list__add-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
            New Prompt
          </button>
        </div>
        @if (concepts().length === 0) {
          <p class="prompt-list__empty">No prompts yet. Add one with New Prompt.</p>
        } @else if (filteredConcepts().length === 0) {
          <p class="prompt-list__empty">No prompts with this tag.</p>
        } @else {
          <ul class="prompt-list__items">
            @for (concept of filteredConcepts(); track concept.concept_id) {
              <li>
                <button
                  type="button"
                  class="prompt-list__row"
                  [class.prompt-list__row--inactive]="!concept.is_active"
                  (click)="openPrompt(concept)"
                  [attr.aria-label]="'Edit prompt: ' + concept.title">
                  <span class="prompt-list__main">
                    <span class="prompt-list__title">{{ concept.title }}</span>
                    @if (promptMeta(concept)) {
                      <span class="prompt-list__meta">{{ promptMeta(concept) }}</span>
                    }
                  </span>
                  <span
                    class="app-picker__status"
                    [class.app-picker__status--active]="concept.is_active"
                    [class.app-picker__status--inactive]="!concept.is_active">
                    {{ concept.is_active ? 'Active' : 'Inactive' }}
                  </span>
                </button>
              </li>
            }
          </ul>
        }
      </div>
      }
      </div>
    }
  </section>
  </div>
  }
</div>
}

<!-- ── Create Concept modal ──────────────────────────────────────────────── -->
@if (showCreateModal()) {
  <div class="concepts-modal-backdrop concepts-modal-backdrop--animate" [class.concepts-modal-backdrop--closing]="createClosing()" role="dialog" aria-modal="true" aria-labelledby="create-modal-title" (click)="closeCreateModal()">
    <div class="concepts-modal concepts-modal--form concepts-modal--animate" [class.concepts-modal--closing]="createClosing()" (click)="$event.stopPropagation()">
      <div class="concepts-modal__header">
        <h3 id="create-modal-title" class="concepts-modal__title">New Prompt</h3>
        <button type="button" class="concepts-modal__close" (click)="closeCreateModal()" aria-label="Close">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <form [formGroup]="createForm" (ngSubmit)="submitCreate()" class="concepts-modal__body" id="create-form">
        <div class="concepts-form__group">
          <label class="concepts-form__label" for="create-title">Title *</label>
          <input id="create-title" formControlName="title" type="text" placeholder="e.g. Weekly summary" class="concepts-form__input"
            [class.concepts-form__input--error]="createForm.get('title')?.invalid && createForm.get('title')?.touched"
            [attr.aria-invalid]="createForm.get('title')?.invalid && createForm.get('title')?.touched">
          @if (createForm.get('title')?.invalid && createForm.get('title')?.touched) {
            <span class="concepts-form__error" role="alert">Title is required</span>
          }
        </div>
        <div class="concepts-form__group">
          <label class="concepts-form__label" for="create-prompt">Prompt *</label>
          <textarea id="create-prompt" formControlName="prompt" rows="4" placeholder="Describe what content should be generated…"
            class="concepts-form__input concepts-form__textarea"
            [class.concepts-form__input--error]="createForm.get('prompt')?.invalid && createForm.get('prompt')?.touched"
            [attr.aria-invalid]="createForm.get('prompt')?.invalid && createForm.get('prompt')?.touched"></textarea>
          @if (createForm.get('prompt')?.invalid && createForm.get('prompt')?.touched) {
            <span class="concepts-form__error" role="alert">Prompt is required</span>
          }
        </div>
        <div class="concepts-form__group concepts-form__group--row">
          <label class="concepts-form__checkbox-label">
            <input type="checkbox" formControlName="generate_image" class="concepts-form__checkbox">
            <span>Generate image</span>
          </label>
          <label class="concepts-form__checkbox-label">
            <input type="checkbox" formControlName="generate_body" class="concepts-form__checkbox">
            <span>Generate body</span>
          </label>
        </div>
        @if (saveError()) { <div class="concepts-form__alert concepts-form__alert--error" role="alert">{{ saveError() }}</div> }
      </form>

      <!-- Language select lives outside the scrollable body so the dropdown isn't clipped -->
      <div class="concepts-modal__lang-section">
        <label class="concepts-form__label" id="create-langs-label">Languages</label>
        @if (createSelectedLangs().length) {
          <div class="lang-chips" aria-label="Selected languages">
            @for (code of createSelectedLangs(); track code) {
              <span class="lang-chip">
                {{ getLangName(code) }}
                <button type="button" class="lang-chip__remove" (click)="removeLang('create', code)" [attr.aria-label]="'Remove ' + getLangName(code)">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              </span>
            }
          </div>
        }
        <div class="lang-select-wrap">
          <button type="button" class="lang-select-btn" (click)="createLangOpen.update(v => !v)"
            aria-haspopup="listbox" [attr.aria-expanded]="createLangOpen()" aria-labelledby="create-langs-label">
            <span>{{ createSelectedLangs().length ? createSelectedLangs().length + ' language' + (createSelectedLangs().length > 1 ? 's' : '') + ' selected' : 'Select languages…' }}</span>
            <svg class="lang-select-arrow" [class.lang-select-arrow--open]="createLangOpen()" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 4.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          </button>
          @if (createLangOpen()) {
            <div class="lang-backdrop" (click)="createLangOpen.set(false)"></div>
            <ul class="lang-dropdown" role="listbox" aria-multiselectable="true" aria-labelledby="create-langs-label">
              @for (lang of languages; track lang.code) {
                <li role="option" [attr.aria-selected]="createSelectedLangs().includes(lang.code)">
                  <button type="button" class="lang-option" [class.lang-option--selected]="createSelectedLangs().includes(lang.code)"
                    (click)="toggleLang('create', lang.code)">
                    <span class="lang-option__check">
                      @if (createSelectedLangs().includes(lang.code)) {
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1.5 6l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
                      }
                    </span>
                    <span>{{ lang.name }}</span>
                    <span class="lang-option__code">{{ lang.code }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>

      <!-- Tags -->
      <div class="concepts-modal__lang-section">
        <label class="concepts-form__label" for="create-tag-input">Tags</label>
        <div class="tag-input-wrap">
          <input
            id="create-tag-input"
            type="text"
            class="tag-input"
            placeholder="Type a tag and press Enter…"
            [ngModel]="createTagInput()"
            (ngModelChange)="createTagInput.set($event)"
            (keydown)="onTagKeydown('create', $event)"
            aria-label="Add tag"/>
          <button type="button" class="tag-add-btn" (click)="addTag('create', createTagInput())" aria-label="Add tag">+</button>
        </div>
        @if (createTags().length) {
          <div class="lang-chips" aria-label="Tags" style="margin-top:0.5rem">
            @for (tag of createTags(); track tag) {
              <span class="lang-chip tag-chip">
                {{ tag }}
                <button type="button" class="lang-chip__remove" (click)="removeTag('create', tag)" [attr.aria-label]="'Remove tag ' + tag">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                </button>
              </span>
            }
          </div>
        }
      </div>

      <div class="concepts-modal__footer">
        <button type="button" class="concepts-modal__btn concepts-modal__btn--primary" (click)="submitCreate()" [disabled]="isSaving() || createForm.invalid">
          @if (isSaving()) { Saving… } @else { Create Prompt }
        </button>
      </div>
    </div>
  </div>
}


<!-- ── Delete confirm modal ──────────────────────────────────────────────── -->
@if (showDeleteModal()) {
  <div class="concepts-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="delete-modal-title" (click)="closeDeleteModal()">
    <div class="concepts-modal concepts-modal--sm" (click)="$event.stopPropagation()">
      <div class="concepts-modal__header">
        <h3 id="delete-modal-title" class="concepts-modal__title concepts-modal__title--danger">Delete Prompt</h3>
        <button type="button" class="concepts-modal__close" (click)="closeDeleteModal()" aria-label="Close">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="concepts-modal__body">
        <p class="concepts-modal__text">Are you sure you want to delete <strong>{{ selectedConcept()?.title }}</strong>? This cannot be undone.</p>
        @if (saveError()) { <div class="concepts-form__alert concepts-form__alert--error" role="alert" style="margin-top:1rem">{{ saveError() }}</div> }
      </div>
      <div class="concepts-modal__footer">
        <button type="button" class="concepts-modal__btn concepts-modal__btn--danger" (click)="confirmDelete()" [disabled]="isSaving()">
          @if (isSaving()) { Deleting… } @else { Delete }
        </button>
      </div>
    </div>
  </div>
}
